// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__W1TTO","btn-icon":"Button_btn-icon__jpocd","icon-hov-scale":"Button_icon-hov-scale__T6uy-"};